import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sourcearea"
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("a-row", {
    attrs: {
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", [_c("a-button", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.addModal();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sourcearea.insert")) + " ")])], 1)], 1), _c("a-table", {
    attrs: {
      loading: _vm.isTableLoading,
      "data-source": _vm.tableDataList,
      rowKey: "id",
      pagination: false
    }
  }, [_c("a-table-column", {
    attrs: {
      "data-index": "name",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _vm._v(" " + _vm._s(text) + " ")], 2)];
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("sourcearea.sourceareaName")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.defaultLangObj.langName) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1)]), _c("a-table-column", {
    attrs: {
      "data-index": "pictureUrl",
      title: _vm.$t("sourcearea.picture"),
      align: "center",
      width: "10%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("img", {
          staticStyle: {
            width: "100px",
            height: "100px"
          },
          attrs: {
            src: _vm.urlHost + text
          }
        })];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("sourcearea.goodsNum"),
      "data-index": "productNumber",
      width: "12%",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("div", {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c("div", {
          staticStyle: {
            "margin-bottom": "4px"
          }
        }, [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.onTheShelf")))]), _vm._v("： "), _c("router-link", {
          staticStyle: {
            "text-decoration": "underline"
          },
          attrs: {
            to: {
              path: "/productmanager/productList",
              query: {
                productStatus: 1,
                productSourceareaid: record.id
              }
            }
          }
        }, [_vm._v(_vm._s(record.productNumberOn || 0))])], 1), _c("div", [_c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.offTheShelf")))]), _vm._v("： "), _c("router-link", {
          staticStyle: {
            "text-decoration": "underline"
          },
          attrs: {
            to: {
              path: "/productmanager/productList",
              query: {
                productStatus: 0,
                productSourceareaid: record.id
              }
            }
          }
        }, [_vm._v(_vm._s(record.productNumberOff || 0))])], 1)])];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("sourcearea.state"),
      "data-index": "status",
      width: "12%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [text == "0" ? [_c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("sourcearea.stop")) + " ")])] : _vm._e(), text == "1" ? [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("sourcearea.enable")) + " ")])] : _vm._e()];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("sourcearea.updateTime"),
      "data-index": "updateTime",
      width: "16%"
    }
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("sourcearea.operate"),
      align: "left",
      width: "16%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("a", {
          on: {
            click: function click($event) {
              return _vm.updata(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("sourcearea.edit")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), record.status == "1" ? _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("sourcearea.sureStop"),
            "ok-text": _vm.$t("sourcearea.ok"),
            "cancel-text": _vm.$t("sourcearea.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.updateStatus(record.id, 0, record);
            }
          }
        }, [_c("a", [_vm._v(_vm._s(_vm.$t("sourcearea.stop")))])]) : _vm._e(), record.status == "0" ? _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("sourcearea.sureEnable"),
            "ok-text": _vm.$t("sourcearea.ok"),
            "cancel-text": _vm.$t("sourcearea.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.updateStatus(record.id, 1, record);
            }
          }
        }, [_c("a", [_vm._v(_vm._s(_vm.$t("sourcearea.enable")))])]) : _vm._e(), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("sourcearea.sureDelete"),
            "ok-text": _vm.$t("sourcearea.ok"),
            "cancel-text": _vm.$t("sourcearea.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.deleteSourceArea(record.id);
            }
          }
        }, [_c("a", [_vm._v(_vm._s(_vm.$t("sourcearea.delete")))])])];
      }
    }])
  })], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.textMap[_vm.dialogStatus],
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      rules: _vm.rules,
      model: _vm.modalValue
    }
  }, [_vm._l(_vm.modalValue.nameList, function (tempObj, index) {
    return [tempObj.required ? [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName,
        prop: "nameList." + index + ".name",
        rules: [{
          required: true,
          message: _vm.errTip,
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("sourcearea.input"),
        maxLength: 100
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)] : [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("sourcearea.input"),
        maxLength: 100
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)]];
  }), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("sourcearea.picture"),
      prop: "sourceAreaPic"
    }
  }, [_c("a-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      name: "file",
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      "before-upload": _vm.beforeUpload,
      data: _vm.updateData
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.imageUrl ? _c("img", {
    staticStyle: {
      width: "128px",
      height: "128px"
    },
    attrs: {
      src: _vm.imageUrl,
      alt: "avatar"
    }
  }) : _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loading ? "loading" : "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("public.upload")) + " ")])], 1)]), _c("div", {
    staticStyle: {
      color: "#f5222f",
      "line-height": "normal"
    }
  }, [_vm._v(_vm._s(_vm.$t("sourcearea.tipsForUploadingPicture", {
    size: "60*60",
    uploadLimit: _vm.uploadLimit
  })))])], 1)], 2), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("sourcearea.cancel")))]), _vm.dialogStatus == "create" ? _c("a-button", {
    attrs: {
      loading: _vm.saveLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.saveModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("sourcearea.ok")) + " ")]) : _vm._e(), _vm.dialogStatus == "update" ? _c("a-button", {
    attrs: {
      loading: _vm.updateLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.updateModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("sourcearea.ok")) + " ")]) : _vm._e()], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };